export default __webpack_public_path__ + "static/intro-vector-4cf9a9adc2d5549b3fc35b8758ccfcc6.png";